module.exports = "https://img1.huilianyi.com/2/icon2.26fe82b0c6.appcore.png";